import React from "react";
import { useRecordContext, useTranslate, FieldProps } from "react-admin";
import { Chip } from "@mui/material";
import { USER_TYPE_OPTIONS } from "@/constants/userType";

type Props = FieldProps & {
  source?: string;
  label?: string;
};

const UserTypeChip: React.FC<Props> = ({
  source = "userGroup.group.name",
  label,
}) => {
  const record = useRecordContext();
  const translate = useTranslate();

  if (!record) return null;

  const rawValue = source.split(".").reduce((obj, key) => obj?.[key], record);
  const value =
    typeof rawValue === "string"
      ? rawValue
      : rawValue?.name || rawValue?.id || "";

  const labelKey =
    USER_TYPE_OPTIONS.find((opt) => opt.value === value)?.label || value;

  return (
    <Chip
      size="small"
      label={translate(labelKey)}
      color="primary"
      title={label}
    />
  );
};

export default UserTypeChip;
